import { Box, Button, IconButton, Tooltip } from '@mui/material';
import FilterButton from '../FilterButton/FilterButton';
import SearchBar from '../SearchBar/SearchBar';
import AddButton from '../AddButton/AddButton';
import FiltersContent from '../Filters/Filters';
import DownloadIcon from '@mui/icons-material/Download';
import './FilterSearchAddBar.css';
import all_interface from '../../../../../asset/image/all_interface.svg';
import lan_interface from '../../../../../asset/image/lan_interface.svg';
import wan_interface from '../../../../../asset/image/wan_interface.svg';
import wifi_interface from '../../../../../asset/image/wifi_interface.svg';
import { useState } from 'react';

interface FilterSearchAddBarProps {
  config?: string[];
  filters?: boolean;
  setFilters?: (value: boolean) => void;
  searchValue?: string;
  setSearchValue?: (value: string) => void;
  onAddClick?: () => void;
  addLabel?: string;
  selectedSite?: string;
  onSiteChange?: (value: string) => void;
  siteButtonLabels?: string[];
  showDownloadButton?: boolean;
  onDownloadClick?: () => void;
  controlHeight?: number;
  filterDropdownContent?: React.ReactNode;
  onInterfaceTypeClick?: (value: string) => void;
}

const FilterSearchAddBar = ({
  config = [],
  filters,
  setFilters,
  searchValue,
  setSearchValue,
  onAddClick,
  addLabel = 'Add Interface',
  selectedSite = '',
  onSiteChange,
  siteButtonLabels = [],
  showDownloadButton = false,
  onDownloadClick,
  controlHeight,
   filterDropdownContent,
   onInterfaceTypeClick
}: FilterSearchAddBarProps) => {
  const showFilterButton = config.includes('filterButton');
  const showSearchBar = config.includes('searchBar');
  const showAddButton = config.includes('addButton');
  const showInterfaceIcons = config.includes('interfaceIcons')
  const buttonHeight = controlHeight || 23;
  const [selectedInterface, setSelectedInterface] = useState<string>("All");

  return (
    <Box
      className="filter-search-add-wrapper"
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'center', sm: 'center' },
        justifyContent: 'space-between',
        width: '100%',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          gap: 1.5,
          flexWrap: 'wrap',
          flex: 1,
          minWidth: 0,
        }}
      >
        {showFilterButton && setFilters !== undefined && filters !== undefined && (
          <FilterButton filters={filters} setFilters={setFilters} height={buttonHeight} />
        )}

        {showSearchBar && searchValue !== undefined && setSearchValue && (
          <Box
            sx={{
              mr: siteButtonLabels.length > 0 ? { xs: 0, sm: 10.5 } : 0,

              width: { xs: '100%', sm: 'auto' },
            }}
          >
            <SearchBar
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              height={buttonHeight}
            />
          </Box>
        )}

        {showInterfaceIcons && (
          <div className="interface-icons-wrapper">
            {[
              { key: "All", icon: all_interface },
              { key: "LAN", icon: lan_interface },
              { key: "WAN", icon: wan_interface },
              { key: "WIFI", icon: wifi_interface },
            ].map(({ key, icon }) => (
              <div
                onClick={() => {
                  setSelectedInterface(key);
                  onInterfaceTypeClick?.(key);
                }}
                className={`interface-icon-container ${selectedInterface === key ? 'active' : ''}`}
              >
                <img
                  src={icon}
                  alt={key}
                  className={`interface-icon ${selectedInterface === key ? 'active' : ''}`}
                />
                {selectedInterface === key && <span className="interface-label">{key}</span>}
              </div>
            ))}
          </div>
        )}

        {siteButtonLabels.length > 0 && (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              width: { xs: '100%', sm: 'auto' },
              flexDirection: 'row',
            }}
          >
            {siteButtonLabels.map((label) => {
              const value = label.toLowerCase().replace(/\s+/g, '-');
              return (
                <Button
                  key={value}
                  variant="outlined"
                  onClick={() => onSiteChange?.(value)}
                  sx={{
                    height: buttonHeight,
                    textTransform: 'none',
                    borderRadius: '4px',
                    fontSize: '14px',
                    border: '1px solid #4B0082',
                    background: selectedSite === value ? '#DADADA' : '#FFFFFF',
                    boxShadow: selectedSite === value ? '0px 4px 4px 0px #00000040 inset' : 'none',
                    color: '#000000',
                    '&:hover': {
                      backgroundColor: selectedSite === value ? '#DADADA' : '#f5f5f5',
                    },
                  }}
                >
                  {label}
                </Button>
              );
            })}
          </Box>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          alignSelf: { xs: 'flex-start', sm: 'center' },
          width: { xs: '100%', sm: 'auto' },
          gap: 1,
          mt: { xs: 2, sm: 0 },
        }}
      >
        {showDownloadButton && (
          <IconButton
            onClick={onDownloadClick}
            sx={{
              width: 28,
              height: 29,
              backgroundColor: '#264C86',
              borderRadius: '4px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                backgroundColor: '#3a006b',
              },
            }}
          >
            <DownloadIcon sx={{ color: '#fff', height: '18px' }} />
          </IconButton>
        )}

        {showAddButton && onAddClick && (
          <AddButton onAddClick={onAddClick} addLabel={addLabel} />
        )}
      </Box>

      {filters && filterDropdownContent}
    </Box>
  );
};

export default FilterSearchAddBar;
